import en from './en.mjs'

export default Object.freeze({
  ...en,
  'common.language.label': 'Idioma',
  'common.download.action': 'Descargar',
  'common.store.appleprefix': 'Descárgalo en',
  'common.store.googleprefix': 'DISPONIBLE EN',
  'seo.home.title': 'Happy Pets | Compañero de IA, tests y widgets',
  'seo.home.description': 'Conoce a una mascota virtual con IA para reflexionar, explorar tu personalidad, consultar tarot y sueños, usar widgets y criar con amigos.',
  'seo.home.keywords': 'Happy Pets, compañero IA, mascota virtual, widget, test de personalidad, MBTI, tarot IA',
  'seo.invite.title': 'Invitación de Happy Pets | Cría una mascota con amigos',
  'seo.invite.description': 'Abre tu invitación de Happy Pets para adoptar o criar una mascota virtual con amigos en iPhone y Android.',
  'nav.skills.label': 'Habilidades',
  'nav.tests.label': 'Tests',
  'nav.guidance.label': 'Guía IA',
  'nav.features.label': 'Funciones',
  'nav.experience.label': 'Experiencia',
  'nav.community.label': 'Comunidad',
  'nav.news.label': 'Noticias',
  'home.hero.titlelead': 'Una mascota pequeña,',
  'home.hero.titleaccent': 'un poco de ayuda cada día',
  'home.hero.subtitle': 'Adopta una acogedora mascota virtual que vive en tu pantalla, crece contigo y aprende habilidades útiles para ayudarte, divertirte y acompañarte.',
  'home.tools.eyebrow': 'Habilidades de tu mascota',
  'home.tools.title': 'Pequeñas tareas diarias en las que puede ayudarte',
  'home.tools.description': 'Convierte a tu mascota en una compañera útil para reflexionar, pensar comidas, conocer tu personalidad y tomar decisiones cotidianas.',
  'home.tools.action': 'Probar ahora',
  'tool.tarot.tag': 'Reflexión',
  'tool.tarot.title': 'Tarot',
  'tool.tarot.description': 'Deja que tu mascota saque una carta y te ayude a mirar tu pregunta desde otra perspectiva.',
  'tool.mbti.tag': 'Personalidad',
  'tool.mbti.title': 'MBTI',
  'tool.mbti.description': 'Explora tu tipo, compara patrones y descubre cómo piensas y conectas con otras personas.',
  'tool.chef.tag': 'Cocina',
  'tool.chef.title': 'Chef de nevera',
  'tool.chef.description': 'Convierte lo que ya tienes en la nevera en comidas sencillas con tu pequeño chef.',
  'tool.fortune.tag': 'Diario',
  'tool.fortune.title': 'Fortuna diaria',
  'tool.fortune.description': 'Empieza el día con una mirada ligera al ánimo, la suerte y los pequeños momentos que vienen.',
  'tool.calorie.tag': 'Salud',
  'tool.calorie.title': 'Calculadora de calorías',
  'tool.calorie.description': 'Estima calorías, detecta patrones de nutrición y elige tus comidas con menos dudas.',
  'tool.dream.tag': 'Sueños',
  'tool.dream.title': 'Interpretación de sueños',
  'tool.dream.description': 'Ordena los símbolos de anoche y convierte fragmentos difusos en temas sobre los que reflexionar.',
  'home.assessments.eyebrow': 'Conócete mejor',
  'home.assessments.title': 'Tests de autodescubrimiento con resultados para explorar',
  'home.assessments.description': 'Haz un test de personalidad, razonamiento, carrera o relaciones y lleva el resultado a tus conversaciones con tu compañero de IA.',
  'home.assessments.action': 'Empezar test',
  'home.assessments.disclaimer': 'Estos tests son para autoconocimiento y entretenimiento. No sustituyen un diagnóstico médico ni el consejo profesional.',
  'assessment.mbti.eyebrow': 'Personalidad',
  'assessment.mbti.title': 'Test de personalidad MBTI',
  'assessment.mbti.description': 'Explora tus preferencias, forma de comunicarte, fortalezas y patrones de crecimiento.',
  'assessment.mbti.meta': '108 preguntas',
  'assessment.sbti.eyebrow': 'Estilo social',
  'assessment.sbti.title': 'Test de personalidad SBTI',
  'assessment.sbti.description': 'Descubre cómo te muestras ante otras personas mediante cinco dimensiones de emoción, acción y energía social.',
  'assessment.sbti.meta': '62 preguntas',
  'assessment.iq.eyebrow': 'Razonamiento',
  'assessment.iq.title': 'Evaluación de razonamiento IQ',
  'assessment.iq.description': 'Resuelve patrones no verbales y compara distintas áreas de razonamiento.',
  'assessment.iq.meta': 'Razonamiento visual',
  'assessment.holland.eyebrow': 'Carrera',
  'assessment.holland.title': 'Intereses profesionales Holland',
  'assessment.holland.description': 'Identifica las actividades y entornos laborales que pueden resultarte más naturales en seis áreas de interés.',
  'assessment.holland.meta': 'Intereses profesionales',
  'assessment.attachment.eyebrow': 'Relaciones',
  'assessment.attachment.title': 'Test de estilo de apego',
  'assessment.attachment.description': 'Reflexiona sobre cercanía, confianza, seguridad e independencia para comprender mejor tus relaciones.',
  'assessment.attachment.meta': 'Perspectiva relacional',
  'home.guidance.eyebrow': 'Un ritual diario amable',
  'home.guidance.title': 'Guía mística con IA centrada en la reflexión',
  'home.guidance.description': 'El tarot, la fortuna diaria y los símbolos de los sueños te ayudan a parar, nombrar lo que sientes y encontrar un siguiente paso manejable. No buscan predecir el futuro, sino aportar claridad y calma.',
  'guidance.tarot.title': 'Tarot con IA',
  'guidance.tarot.description': 'Elige cartas sobre una pregunta y usa la lectura como una invitación amable a reflexionar y cambiar de perspectiva.',
  'guidance.tarot.note': 'Para reflexión y entretenimiento',
  'guidance.fortune.title': 'Fortuna diaria',
  'guidance.fortune.description': 'Empieza el día observando de forma ligera tu ánimo, energía, detalles de suerte y consejos prácticos.',
  'guidance.fortune.note': 'Una guía nueva cada día',
  'guidance.dream.title': 'Interpretación de sueños',
  'guidance.dream.description': 'Convierte imágenes y emociones de tus sueños en temas para explorar, sin tratarlos como predicciones fijas.',
  'guidance.dream.note': 'Símbolos, emociones y reflexión',
  'home.features.eyebrow': 'Habilidades útiles, alegría diaria',
  'home.features.title': 'Por qué tu mascota se vuelve tan útil',
  'feature.raise.title': 'Cría mascotas adorables',
  'feature.raise.description': 'Aliméntalas, juega y míralas crecer hasta convertirse en compañeras tiernas, reconfortantes y útiles.',
  'feature.hatch.title': 'Incuba nuevas habilidades',
  'feature.hatch.description': 'Colecciona huevos y descubre mascotas únicas con distintas personalidades y habilidades.',
  'feature.coraising.title': 'Cría con tus mejores amigos',
  'feature.coraising.description': 'Invita a tus amigos a cuidarlas juntos: doble cariño, doble diversión.',
  'feature.status.title': 'Estado diario',
  'feature.status.description': 'Registra cómo estás cada día y comparte tus sentimientos con tu mascota.',
  'feature.frequency.title': 'Frecuencia diaria',
  'feature.frequency.description': 'Crea eventos y sigue hábitos como beber agua, correr y mucho más.',
  'feature.cleaner.title': 'Limpiador de fotos',
  'feature.cleaner.description': 'Ordena tu galería mientras juegas. Divertido y productivo.',
  'feature.skills.title': 'Sala de habilidades IA',
  'feature.skills.description': 'Desbloquea nuevos estilos y descubre más ayuda para reflexionar, planificar y vivir el día a día.',
  'feature.widget.title': 'Widget interactivo',
  'feature.widget.description': 'Mantén a tu mascota cerca con widgets interactivos en la pantalla de inicio.',
  'home.steps.eyebrow': 'Primeros pasos',
  'home.steps.title': 'Incuba una mascota con habilidades útiles',
  'step.adopt.title': 'Adopta',
  'step.adopt.description': 'Elige un huevo único y empieza tu viaje con una mascota propia.',
  'step.grow.title': 'Crece',
  'step.grow.description': 'Alimenta, juega e interactúa cada día para ayudarla a crecer y aprender nuevas habilidades.',
  'step.together.title': 'Juntos',
  'step.together.description': 'Invita a tus amigos y deja que vuestras mascotas compartan un mundo lleno de personalidad y apoyo.',
  'home.reviews.eyebrow': 'Comunidad',
  'home.reviews.title': 'Querida por mucho más que su ternura',
  'home.reviews.role': 'Familia de mascota',
  'home.news.eyebrow': 'Noticias e historias',
  'home.news.title': 'Últimas noticias',
  'home.news.description': 'Ideas amables sobre la vida con tu mascota, el autodescubrimiento y el bienestar diario.',
  'home.news.readarticle': 'Leer artículo',
  'home.news.exploreall': 'Ver todas las noticias',
  'review.one.text': 'Mi mascota es adorable, pero lo que más me sorprendió es cuánto uso sus pequeñas habilidades diarias.',
  'review.two.text': 'Criarla con mi novio nos da mucha alegría y sus habilidades extra resultan útiles todos los días.',
  'review.three.text': 'Los widgets son muy interactivos. Me encanta tener una compañera bonita que además me ayuda en el día a día.',
  'home.footer.tagline': 'Lleva alegría y compañía a tu pantalla de inicio.',
  'home.footer.product': 'Producto',
  'home.footer.support': 'Ayuda',
  'home.footer.social': 'Social',
  'home.footer.skills': 'Habilidades',
  'home.footer.features': 'Funciones',
  'home.footer.widgets': 'Widgets',
  'home.footer.help': 'Centro de ayuda',
  'home.footer.privacy': 'Privacidad',
  'home.footer.terms': 'Términos',
  'home.footer.copyright': '© 2024 Happy Pet. Todos los derechos reservados.',
  'home.image.logoalt': 'Logo de Happy Pets',
  'home.image.screenalt': 'Pantalla de la app Happy Pets',
  'home.image.enlargedalt': 'Pantalla ampliada de Happy Pets',
  'home.image.close': 'Cerrar imagen',
  'invite.headline': '¡Tus amigos te invitan a criar una mascota juntos!',
  'invite.description': 'Acepta la invitación y el huevo eclosionará al instante. Añade tu mascota a la pantalla de inicio.',
  'invite.download': 'Descargar',
  'invite.loadingalt': 'Cargando Happy Pets',
  'invite.screensalt': 'Capturas de la app Happy Pets'
})
